import { commandPost, toastOk, toastError } from "@/lib/commands/api";
import {
  AdjustLedgerPanel,
  BumpPayoutPanel,
} from "@/components/command-bar/panels";
import type { Command } from "@/lib/commands/types";

// Payouts commands are all gated by feature_contractor_payouts.
// Bumps and sweeps are dispatcher-only; tax form generation is
// gated separately under org:payouts:tax.
export const commandsPayouts: Command[] = [
  {
    id: "payouts.bump_offer",
    label: "Bump driver payout",
    description: "Raise the offer to encourage acceptance.",
    group: "payouts",
    scope: "load_detail",
    hotkey: { mod: ["mod"], key: "b" },
    permission: "org:payouts:write",
    featureFlag: "feature_contractor_payouts",
    handler: { kind: "panel", open: BumpPayoutPanel },
  },
  {
    id: "payouts.adjust_ledger",
    label: "Adjust driver ledger",
    group: "payouts",
    scope: "driver_detail",
    permission: "org:payouts:adjust",
    featureFlag: "feature_contractor_payouts",
    handler: { kind: "panel", open: AdjustLedgerPanel },
  },
  {
    id: "payouts.sweep_driver",
    label: "Sweep driver balance now",
    description: "Disburse the available balance immediately.",
    group: "payouts",
    scope: "driver_detail",
    permission: "org:payouts:write",
    featureFlag: "feature_contractor_payouts",
    confirmation: {
      title: "Sweep driver balance?",
      body: "Transfers the available balance via Stripe immediately.",
      confirmLabel: "Sweep",
    },
    handler: {
      kind: "mutation",
      run: async (ctx) => {
        try {
          await commandPost(`/api/v1/payouts/drivers/${ctx.driverId}/sweep`);
          toastOk("Sweep initiated");
        } catch (e) {
          toastError(e instanceof Error ? e.message : "Failed to sweep");
          throw e;
        }
      },
    },
  },
];
